<template>
  <div class="w-100pct">
    <div class="item-list f-left w-100pct pd-vtc-10px al-center" v-for="(item, index) in items" :key="index">
      <div class="w-15pct f-left">
        <img :src="item.image" alt="" width="100%">
      </div>
      <div class="w-85pct f-left t-al-left pd-l-10px">
        <div>
          <span class="f-s-16px f-w-bold">{{ item.name }}</span>
        </div>
        <div>
          <span class="">{{ item.option }}</span>
        </div>
        <div>
          <span class="f-s-16px f-w-bold"> ฿ {{ item.priceDiscount | showFullPriceFormat()}}</span>
        </div>
        <div class="dp-flex jtf-ct-space-between">
          <div class="w-80pct">
            <strike v-if="item.priceDiscount != item.price">฿ {{ item.price | showFullPriceFormat() }}</strike>
          </div>
          <div class="w-20pct">
            <svg-filler class="cs-pointer"  @click="confirmCustomDelete(item)" path="/static/svg/trash-alt-regular.svg" :fill="'#000000'" width="20px" height="20px"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    confirmCustomDelete (item) {
      this.$emit('removeItem', item)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.item-list {
  border-bottom: 1px solid;
  border-color: #cfcfcf;
}

.remove-icon {
  color: #d2d2d2;
}
</style>



// WEBPACK FOOTER //
// src/views/cart/ListCart.vue